import React from "react";

import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import Header from "components/layout/Header";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";

const CoolCompanyVsInvozio = () => {
  const comparison3 = `${blobURL}/comparison-3.jpg`;

  const { t } = useTranslation();

  return (
    <div className="network-page">
      <Helmet>
        <title>{t("With Invozio, you get more than with Gigger")}</title>
        <meta
          name="description"
          content={t(
            "With Invozio, you get more money than you do on Gigger. Invozio has more features, is simpler, and more cost-effective compared to Gigger. Try it today."
          )}
        />
        <meta name="keywords" content="gigger"></meta>
      </Helmet>

      <Header />

      <div className="p-0 self_new negotiate network-page mb-0 nw_add_scc busniness_new">
        <div className="negotiation_wrap new_desgn_insurance inspiration fakt new_margin_header px-0 p-0">
          <Container className="self_new responsive_self">
            <div className="seo_pages">
              <section className="insurns_wrap self-empoyee">
                <div className="container">
                  <div className="row align-items-center p-2">
                    <div className="col-lg-6">
                      <div className="slf_text">
                        <h1 className="security_about text-uppercase mb-0">
                          Gigger vs Invozio
                        </h1>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="text-right">
                        <img
                          src={comparison3}
                          alt="Gigger"
                          className="img-fluid"
                          style={{
                            borderRadius: "20px",
                            width: "380px",
                            height: "320px",
                            padding: "12px",
                          }}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="newdesign">
                <div className="container p-0">
                  <div className="without_background">
                    <h1 className="heading_edit">Gigger</h1>
                    <div className="new_text">
                      <p>
                        {t(
                          "Gigger is one of the major players in Sweden for freelancers in all types of industries and companies. They offer a platform for invoicing without their own company, handling taxes, customer support, handling ROT and RUT together with third parties, deduction possibilities, international invoicing, collective agreements and comprehensive insurance solutions."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t("Overall comparison Gigger and Invozio")}
                      </h3>
                      <p>
                        {t(
                          "At Invozio, we strive to become a leading player in the market by offering favorable conditions for our users. Like Gigger, we provide a service where freelancers, small businesses and consultants can easily invoice without setting up their own company. In the same way as Gigger, we also handle tax, fees and other administration for our clients. What sets Invozio apart is our efficiency and ease of use in invoicing, combined with a range of features designed to simplify the management of invoices for our customers."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t(
                          "Among the leading companies, the race is often even"
                        )}
                      </h2>
                      <p>
                        {" "}
                        {t(
                          "Invozio and Gigger are central players in the market with a focus on delivering invoicing and financial services specifically designed for freelancers and smaller businesses. Their main objective is to reduce the administrative and legal burden, along with financial tasks such as bookkeeping, which are common in conventional business operations. These services greatly facilitate individuals to function as independent entrepreneurs. With a focus on drastically reducing the time it takes to manage documentation and taxes, these platforms offer a solution where customers can focus more on what they do best - their core business. Although both these companies operate in the same sector, they present unique characteristics in terms of what they offer, their user interface, various features and also in their pricing structures. This means that depending on an individual's or a company's unique requirements and goals, either Invozio or Gigger may prove to be the optimal choice."
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="with_background">
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t(
                          "Who do you get the most Cool Company money from - Invozio or Gigger?"
                        )}
                      </h2>
                      <p>
                        {t(
                          "Let's take a look at how much a freelancer would earn when billing 10,000 SEK through each platform, based on the information on their websites."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">Invozio</h3>
                      <p>
                        {t(
                          "With Invozio, the fee is 1.9%. So if you invoice SEK 10,000, the fee would be SEK 190. The freelancer thus receives SEK 9,810."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins"> Gigger</h3>
                      <p>
                        {t(
                          "Gigger charges a fee of 3.5%. So if you invoice SEK 10,000, the fee would be SEK 350. The freelancer thus receives SEK 9,650. Based on these numbers and without taking into account any additional services or benefits that may be offered by each platform, it would appear that the freelancer is making more money per dollar billed through Invozio compared to Gigger. So if you want more in your wallet every month, you should turn to Invozio."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default CoolCompanyVsInvozio;
